export const sendBlobToBrowserDownload = (
  fileName: string,
  fileExtension: string,
  blob: Blob
) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${fileName}.${fileExtension}`);
  document.body.appendChild(link);
  link.click();
};
